import React from "react";
import ReportedUserCard from "./ReportedUserCard";
import type { ReportedUserApi } from "../ReportedUsersPage";

interface ReportedUserGridProps {
  reportedUsers: ReportedUserApi[];
  loading: boolean;
  onUserClick: (user: ReportedUserApi) => void;
  onActionClick: (user: ReportedUserApi, e?: React.MouseEvent) => void;
}

const ReportedUserGrid: React.FC<ReportedUserGridProps> = ({ reportedUsers, loading, onUserClick, onActionClick }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <svg className="animate-spin h-8 w-8 text-[#4f6df5]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" strokeDasharray="30" strokeLinecap="round" />
        </svg>
        <p className="mt-4 text-sm text-gray-500">Obteniendo reportes...</p>
      </div>
    );
  }

  if (reportedUsers.length === 0) {
    return (
      <div className="text-center py-20 border-2 border-dashed border-gray-200 bg-gray-50/50 rounded-xl text-gray-500 text-sm">
        No se encontraron usuarios reportados. ¡Excelentes noticias!
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-4">
      {reportedUsers.map((user) => (
        <ReportedUserCard
          key={user.reportedUserId}
          user={user}
          onUserClick={onUserClick}
          onActionClick={onActionClick}
        />
      ))}
    </div>
  );
};

export default ReportedUserGrid;